<script setup lang="ts">
const props = defineProps<{ itemName: string }>()
const emit = defineEmits(["close", "confirm"])
</script>

<template>
  <div class="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center">
    <div class="bg-white p-6 rounded w-96">
      <h2 class="text-lg font-bold mb-4">Confirm Delete</h2>
      <p class="mb-4">Are you sure you want to delete <b>{{ props.itemName }}</b>?</p>

      <div class="flex justify-end gap-2">
        <button
          @click="emit('close')"
          class="px-4 py-2 bg-gray-300 rounded"
        >
          Cancel
        </button>
        <button
          @click="emit('confirm')"
          class="px-4 py-2 bg-red-500 text-white rounded"
        >
          Delete
        </button>
      </div>
    </div>
  </div>
</template>
